module.exports = __webpack_public_path__ + "static/media/CSharpIcon.07407185.svg";